import {AaNaturalAnalog} from 'graphql-client/__generated/graphqlGlobalTypes';
import {MonomerUpdate, MonomerValidationInput} from 'molbio/monomers/MonomersDAO';
import {SharedMonomerValidationOutput} from 'molbio/monomers/SharedMonomerConstants';
import {patchJSONPromise, postJSONPromise} from 'util/Net';

export interface APIAaMonomer {
  name: string;
  symbol: string;
  naturalAnalog: AaNaturalAnalog;
  smiles: string;
  color: string;
}

export async function createAaMonomers(monomers: Array<APIAaMonomer>): Promise<{createdIds: Array<string>}> {
  return await postJSONPromise({
    url: '/1/api/aa-monomers',
    data: {monomers},
  });
}

export async function updateAaMonomer(
  aaMonomerId: string,
  data: MonomerUpdate
): Promise<{updatedIds: Array<string>}> {
  return await patchJSONPromise({
    url: '/1/api/aa-monomers',
    data: {monomers: [{id: aaMonomerId, ...data}]},
  });
}

export async function validateAaMonomerInput(
  monomerDicts: Array<MonomerValidationInput>
): Promise<Array<SharedMonomerValidationOutput>> {
  return await postJSONPromise({
    url: '/1/api/aa-monomers:validate',
    data: {monomerDicts},
  });
}
